import React from 'react';
import { Modal } from 'react-bootstrap';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { config } from '_config';
import { ICON_ALIASES } from '_constants/icons';
import { MODAL_KEYS } from '_constants/modals';
import { theme } from '_constants/theme';
import { getMeetings } from '_store/meetings/slice';
import { selectModalVisibleByKey } from '_store/modals/selector';
import { hideModal } from '_store/modals/slice';
import { selectCustomerId, selectDetails as selectUserDetails } from '_store/user/selector';

import Icon from 'components/atomic/Icon';

const StyledModalBody = styled(Modal.Body)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  border-radius: inherit;

  .calendly-inline-widget {
    width: 100%;

    iframe {
      border-radius: var(--bs-modal-border-radius);
    }
  }
`;

const StyledCloseActionContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: ${-theme.spaces.large3X}px;
  right: 0;
  font-family: 'Inter';
  font-style: normal;
  font-size: ${theme.fontSizes.regular}px;
  font-weight: 400;
  color: ${theme.colors.white};
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  margin-right: ${theme.spaces.small2X}px;
`;

const AppointmentSchedulingModal = () => {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const userDetails = useSelector(selectUserDetails);
  const visible = useSelector(selectModalVisibleByKey(MODAL_KEYS.appointmentScheduling));

  useCalendlyEventListener({
    onEventScheduled: () => {
      dispatch(getMeetings({ customerId }));
    },
  });

  const handleClose = () => {
    dispatch(hideModal({ key: MODAL_KEYS.appointmentScheduling }));
  };

  return (
    <Modal
      dialogClassName="appointment-scheduling-modal"
      show={visible}
      backdrop="static"
      keyboard={false}
      centered
      onHide={handleClose}
    >
      <StyledModalBody>
        <StyledCloseActionContainer onClick={handleClose}>
          <StyledIconContainer>
            <Icon alias={ICON_ALIASES.close} color={theme.colors.white} />
          </StyledIconContainer>
          Close
        </StyledCloseActionContainer>
        <InlineWidget
          url={config.calendlyUrl}
          prefill={{
            email: userDetails?.email,
            phone: userDetails?.phone,
            firstName: userDetails?.firstName,
            lastName: userDetails?.lastName,
            name: `${userDetails?.firstName} ${userDetails?.lastName}`,
            smsReminderNumber: userDetails?.phone,
          }}
        />
      </StyledModalBody>
    </Modal>
  );
};

export default AppointmentSchedulingModal;
